import type { ReactNode } from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';

import AppLogos from './AppLogos/AppLogos';
import Header from './Header/Header';

const logosRowStyle = xcss({
  width: '100%',
});

interface HeadlineProps {
  icon?: ReactNode;
  product?: string;
}

const Headline = ({ icon, product }: HeadlineProps) => {
  return (
    <Flex direction="column" gap="space.500">
      <Box xcss={logosRowStyle}>
        <AppLogos icon={icon} />
      </Box>
      <Header product={product} />
    </Flex>
  );
};

export default Headline;
